// extracted by mini-css-extract-plugin
export default {"responsiveWidth":"styles__responsiveWidth___gMehy","description":"styles__description___qOtwh"};